define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var RoleModel = /** @class */ (function () {
        function RoleModel(data) {
            this.Id = ko.observable(0);
            this.UserSelected = ko.observable(false);
            this.Parent = ko.observable();
            this.Child = ko.observable();
            this.Description = ko.observable();
            this.RadioValue = ko.observable();
            this.IsRadio = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, RoleModel.Mapping, self);
            }
        }
        RoleModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new RoleModel(options.data);
            }
        };
        return RoleModel;
    }());
    return RoleModel;
});
//# sourceMappingURL=RoleModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/RoleModel.js
// module id = 275
// module chunks = 2